import { useCallback } from "react";
import { DocumentData, DocumentSnapshot } from "firebase/firestore";
import { useCreateLetter } from "./useCreateLetter";
import { useAuthorFields } from "./useAuthorFields";
import { useCurrentUser } from "./useCurrentUser";
import { DEFAULT_SALUTATION } from "../components/web/components/SalutationField";

export const useCreateCoverLetter = () => {
  const [user] = useCurrentUser();
  const [createLetter, isLoading, isReady] = useCreateLetter("cover");
  const author = useAuthorFields(user);

  const createCoverLetter = useCallback(
    (object: DocumentSnapshot<DocumentData>) => {
      const address = object.get("owner") ?? "";
      const salutation = object.get("salutation") ?? DEFAULT_SALUTATION;
      const objectAddress = object.get("address") ?? "";

      const protocolAuthorRef =
        (object.get("protocolAuthorRef") as string) ?? "";

      const payload = {
        address,
        salutation,
        author,
        objectAddress,
      };

      return createLetter(payload, protocolAuthorRef);
    },
    [createLetter, author]
  );

  return [createCoverLetter, isLoading, isReady] as const;
};
